import React from "react";
import MediaQuery from "react-responsive";
import PropTypes from "prop-types";
export default class MobileOnly extends React.Component {
  render() {
    return <MediaQuery maxWidth={this.props.maxWidth || 767}>{this.props.children}</MediaQuery>;
  }
}
MobileOnly.propTypes = { children: PropTypes.element.isRequired, maxWidth: PropTypes.number };
